import React from "react";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container footer__bar">
        <div className="footer__left">
          <span>© {new Date().getFullYear()} The Bulls Trading Academy. All rights reserved.</span>
        </div>
        <div className="footer__right">
          <a href="#home">Home</a>
          <a href="#levels">Programs</a>
          <a href="#faq">FAQ</a>
          <a href="#contact">Contact</a>
        </div>
      </div>
      
    </footer>
  );
}
